import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

export const getTeamGraph = (filterResult: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `capacity/team-tab?where=${filterResult}`
  );
};
export const getTradeGraph = (filterResult: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `capacity/trade-tab?where=${filterResult}`
  );
};
export const getShiftGraph = (filterResult: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `capacity/shift-tab?where=${filterResult}`
  );
};
export const getTradePersonGraph = (filterResult: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `capacity/tradeperson-tab?where=${filterResult}`
  );
};
